import $ from 'jquery';
import { tns, } from 'tiny-slider/src/tiny-slider';

class productsCarousel {
  constructor(el) {
    this.el = el;
    this.options = {
      container: this.el,
      items: 1,
      nav: false,
      mouseDrag: true,
      loop: false,
      /*eslint max-len:0*/
      controlsText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">\n' +
        '    <g fill="none" fill-rule="evenodd">\n' +
        '        <circle cx="32" cy="32" r="31.5" fill="#015542" stroke="#85714D"/>\n' +
        '        <path stroke="#F4F2E4" stroke-linejoin="round" stroke-width="2" d="M28 24l8 8-8 8"/>\n' +
        '    </g>\n' +
        '</svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">\n' +
        '    <g fill="none" fill-rule="evenodd">\n' +
        '        <circle cx="32" cy="32" r="31.5" fill="#015542" stroke="#85714D"/>\n' +
        '        <path stroke="#F4F2E4" stroke-linejoin="round" stroke-width="2" d="M28 24l8 8-8 8"/>\n' +
        '    </g>\n' +
        '</svg>'
      ],
      responsive: {
        320: {
          items: 1.23,
          controls: false,
          gutter: 8,
          container: '.cards',
          fixedWidth: 284,
        },
      },
    };

    return this.initSlider();
  }

  initSlider() {
    return tns(this.options);
  }
}


const initproductCarousel = function () {
  let productSliders = document.querySelectorAll('.js-products_carousel');
  if($(window).width() < 768){
    productSliders.forEach(event => {
      new productsCarousel(event);
    });
  }
};

export default initproductCarousel;
